export default __webpack_public_path__ + "static/media/attendance_import.9a74ac56.xlsx";